import {ClassicEditor as ClassicEditorBase} from '@ckeditor/ckeditor5-editor-classic';
import {Essentials} from '@ckeditor/ckeditor5-essentials';
import {Autoformat} from '@ckeditor/ckeditor5-autoformat';
import {Bold, Italic} from '@ckeditor/ckeditor5-basic-styles';
import {BlockQuote} from '@ckeditor/ckeditor5-block-quote';
import {Heading} from '@ckeditor/ckeditor5-heading';
import {Link} from '@ckeditor/ckeditor5-link';
import {List} from '@ckeditor/ckeditor5-list';
import {Paragraph} from '@ckeditor/ckeditor5-paragraph';
import {Alignment} from '@ckeditor/ckeditor5-alignment';
import {Image, AutoImage} from '@ckeditor/ckeditor5-image';
import {MediaEmbed} from '@ckeditor/ckeditor5-media-embed';
import {Markdown} from '@ckeditor/ckeditor5-markdown-gfm';

export default class ClassicEditor extends ClassicEditorBase {
}

function overwriteConfig(id, defaultConfig) {
    $(id).each(function (i, v) {
        let customConfig = null;

        if ($(v).data('ck-config')) {
            customConfig = $(v).data('ck-config')
        }
        ClassicEditor
            .create(v, customConfig ?? defaultConfig)
            .then((editor) => {
                $(v).addClass('ckeditor-initialised')
                v.ckeditor = editor;
                $(v).closest('form').on('submit', () => {
                    editor.updateSourceElement();
                });
            })
            .catch(error => {
                console.log(error);
            });
    })
}


$(document).ready(function () {
    let locale = $('html').attr('lang');

    const advancedCkEditorConfig = window.advancedCkEditorConfig ??= {
        plugins: [Essentials, Autoformat, Bold, Italic, BlockQuote, Heading, Link, List, Paragraph, Alignment, Image, AutoImage, MediaEmbed],
        alignment: {
            options: ['left', 'center', 'right']
        },
        toolbar: {
            items: ['undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'alignment', 'link', 'blockQuote', "mediaEmbed", '|', 'bulletedList', 'numberedList']
        },
        heading: {
            options: [{model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'}, {
                model: 'heading1',
                view: 'h1',
                title: 'Heading 1',
                class: 'ck-heading_heading1'
            }, {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'}]
        },
        language: locale
    };
    overwriteConfig("textarea.ckeditor-advanced:not(.ckeditor-initialised)", advancedCkEditorConfig);

    const simpleCkEditorConfig = window.simpleCkEditorConfig ??= {
        plugins: [Essentials, Autoformat, Bold, Italic, Link, List, Paragraph],
        toolbar: ["bold", "italic", "link", "bulletedList", "numberedList"],
        language: locale
    };
    overwriteConfig("textarea.ckeditor-simple:not(.ckeditor-initialised)", simpleCkEditorConfig);

    const markdownCkEditorConfig = window.markdownCkEditorConfig ??= {
        plugins: [Essentials, Markdown, Autoformat, Bold, Italic, BlockQuote, Link, List, Paragraph, Heading],
        toolbar: ["bold", "italic", "link", "bulletedList", "numberedList", '|', 'heading'],
        language: locale
    };
    window.loadMarkdownCkeditor = function () {
        overwriteConfig("textarea.ckeditor-markdown:not(.ckeditor-initialised)", markdownCkEditorConfig);
    }
    overwriteConfig("textarea.ckeditor-markdown:not(.ckeditor-initialised)", markdownCkEditorConfig);


    window.getCkeditorInstanceByElement = (element) => {
        if (!element instanceof jQuery) {
            element = $(element);
        }

        return element
            .siblings('.ck-editor').first()
            .find('.ck-editor__editable')[0].ckeditorInstance
    }
});

